"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.COMPANY_STORE_DISTRIBUTIONS = void 0;
var client_1 = require("@apollo/client");
exports.COMPANY_STORE_DISTRIBUTIONS = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query CompanyStoreDistributions($companyStoreId: ID!) {\n    distributions(companyStoreId: $companyStoreId) {\n      storeDistributedUpcs\n    }\n  }\n"], ["\n  query CompanyStoreDistributions($companyStoreId: ID!) {\n    distributions(companyStoreId: $companyStoreId) {\n      storeDistributedUpcs\n    }\n  }\n"])));
var templateObject_1;
